import React from 'react';
import BookingWidget from './components/BookingWidget';
import './Home.css';

const Home = () => {
  return (
    <div className="home-page">
      <section className="hero1">
        <div className="hero-bg" />
        <div className="hero-inner">
          <span className="hero-chip">⚡ Instant booking • Verified drivers</span>
          <h1>
            Ride anywhere,<br />
            <span>pay only for the distance.</span>
          </h1>
          <p className="hero-sub">
            Book instant cabs, one-way drops, round trips, rentals and outstation cabs —
            transparent pricing, no surprises.
          </p>
        </div>
      </section>

      <section className="widget-wrap">
        <BookingWidget />
      </section>

      <section className="perks">
        <div className="perk">
          <div className="perk-icon">💸</div>
          <h3>Transparent fares</h3>
          <p>See your fare upfront — no hidden charges.</p>
        </div>
        <div className="perk">
          <div className="perk-icon">🛡️</div>
          <h3>Safety first</h3>
          <p>Verified drivers, live tracking, 24×7 support.</p>
        </div>
        <div className="perk">
          <div className="perk-icon">🚕</div>
          <h3>Wide fleet</h3>
          <p>Hatchback, Sedan, SUV, MUV and Premium.</p>
        </div>
      </section>

      <section className="how">
        <h2>How it works</h2>
        <ol className="steps">
          <li><span>1</span> Choose Instant, Rental or Outstation</li>
          <li><span>2</span> Enter pickup &amp; drop</li>
          <li><span>3</span> Choose an available cab or package</li>
          <li><span>4</span> Confirm your booking and follow payment details</li>
        </ol>
      </section>
    </div>
  );
};

export default Home;